module.exports = __webpack_public_path__ + "assets/img/discernment_clothing_scene2.f1c07f7e.png";